module.exports = __webpack_public_path__ + "img/CE.1822c86f.png";